export default "__VITE_ASSET__D$jPNllt__"